/**
 * @license
 * Copyright (c) Dominic Carretto
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/trimox/angular-mdc-web/blob/master/LICENSE
 */
import { InjectionToken, Directive, ElementRef, EventEmitter, Component, ChangeDetectionStrategy, ViewEncapsulation, NgZone, ChangeDetectorRef, Optional, Inject, Input, Output, ViewChild, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MdcIconModule } from '@angular-mdc/web/icon';
import { MdcTabIndicator, MdcTabIndicatorModule } from '@angular-mdc/web/tab-indicator';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Subject, fromEvent } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MDCComponent } from '@angular-mdc/web/base';
import { MdcRipple } from '@angular-mdc/web/ripple';
import { MDCTabFoundation } from '@material/tab';
import { MDCRippleFoundation } from '@material/ripple';

/**
 * @fileoverview added by tsickle
 * Generated from: tab/tab.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Injection token used to provide the parent MdcTabBar component to MdcTab.
 * @type {?}
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular-mdc/web/ripple';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@angular-mdc/web/icon';
import * as ɵngcc4 from '@angular-mdc/web/tab-indicator';

const _c0 = ["content"];
const _c1 = ["ripplesurface"];
const _c2 = ["mdcTab", ""];
function MdcTab_mdc_icon_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mdc-icon", 8);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.icon);
} }
function MdcTab_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 9);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.label);
} }
function MdcTab_ng_container_6_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function MdcTab_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, MdcTab_ng_container_6_ng_container_1_Template, 1, 0, "ng-container", 10);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r5 = ɵngcc0.ɵɵreference(9);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r5);
} }
function MdcTab_ng_container_7_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function MdcTab_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, MdcTab_ng_container_7_ng_container_1_Template, 1, 0, "ng-container", 10);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r5 = ɵngcc0.ɵɵreference(9);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r5);
} }
function MdcTab_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "mdc-tab-indicator");
} }
const _c3 = [[["mdc-icon"]], "*"];
const _c4 = ["mdc-icon", "*"];
const MDC_TAB_BAR_PARENT_COMPONENT = new InjectionToken('MDC_TAB_BAR_PARENT_COMPONENT');
/** @type {?} */
let nextUniqueId = 0;
class MdcTabLabel {
    /**
     * @param {?} elementRef
     */
    constructor(elementRef) {
        this.elementRef = elementRef;
    }
}
MdcTabLabel.ɵfac = function MdcTabLabel_Factory(t) { return new (t || MdcTabLabel)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
MdcTabLabel.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcTabLabel, selectors: [["mdc-tab-label"], ["", "mdcTabLabel", ""]], hostAttrs: [1, "mdc-tab__text-label"] });
/** @nocollapse */
MdcTabLabel.ctorParameters = () => [
    { type: ElementRef }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcTabLabel, [{
        type: Directive,
        args: [{
                selector: 'mdc-tab-label, [mdcTabLabel]',
                host: { 'class': 'mdc-tab__text-label' }
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, null); })();
class MdcTabIcon {
    /**
     * @param {?} elementRef
     */
    constructor(elementRef) {
        this.elementRef = elementRef;
    }
}
MdcTabIcon.ɵfac = function MdcTabIcon_Factory(t) { return new (t || MdcTabIcon)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
MdcTabIcon.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcTabIcon, selectors: [["mdc-tab-icon"], ["", "mdcTabIcon", ""]], hostAttrs: [1, "mdc-tab__icon"] });
/** @nocollapse */
MdcTabIcon.ctorParameters = () => [
    { type: ElementRef }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcTabIcon, [{
        type: Directive,
        args: [{
                selector: 'mdc-tab-icon, [mdcTabIcon]',
                host: { 'class': 'mdc-tab__icon' }
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, null); })();
class MdcTab extends MDCComponent {
    /**
     * @param {?} _ngZone
     * @param {?} _changeDetectorRef
     * @param {?} _ripple
     * @param {?} elementRef
     * @param {?} _parent
     */
    constructor(_ngZone, _changeDetectorRef, _ripple, elementRef, _parent) {
        super(elementRef);
        this._ngZone = _ngZone;
        this._changeDetectorRef = _changeDetectorRef;
        this._ripple = _ripple;
        this.elementRef = elementRef;
        this._parent = _parent;
        /**
         * Emits whenever the component is destroyed.
         */
        this._destroy = new Subject();
        this._uniqueId = `mdc-tab-${++nextUniqueId}`;
        this.id = this._uniqueId;
        this._stacked = false;
        this._fixed = false;
        this._disabled = false;
        this._focusOnActivate = true;
        this.interacted = new EventEmitter();
        this._root = this.elementRef.nativeElement;
    }
    /**
     * @return {?}
     */
    get stacked() {
        return this._stacked;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set stacked(value) {
        /** @type {?} */
        const newValue = coerceBooleanProperty(value);
        if (newValue !== this._stacked) {
            this._stacked = newValue;
        }
    }
    /**
     * @return {?}
     */
    get fixed() {
        return this._fixed;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set fixed(value) {
        /** @type {?} */
        const newValue = coerceBooleanProperty(value);
        if (newValue !== this._fixed) {
            this._fixed = newValue;
            this._changeDetectorRef.detectChanges();
        }
    }
    /**
     * @return {?}
     */
    get disabled() {
        return this._disabled;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set disabled(value) {
        this._disabled = coerceBooleanProperty(value);
    }
    /**
     * @return {?}
     */
    get focusOnActivate() {
        return this._focusOnActivate;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set focusOnActivate(value) {
        /** @type {?} */
        const newValue = coerceBooleanProperty(value);
        if (newValue !== this._focusOnActivate) {
            this._focusOnActivate = newValue;
            this._foundation.setFocusOnActivate(this._focusOnActivate);
        }
    }
    /**
     * @return {?}
     */
    getDefaultFoundation() {
        /** @type {?} */
        const adapter = {
            setAttr: (/**
             * @param {?} attr
             * @param {?} value
             * @return {?}
             */
            (attr, value) => this._getHostElement().setAttribute(attr, value)),
            addClass: (/**
             * @param {?} className
             * @return {?}
             */
            (className) => this._getHostElement().classList.add(className)),
            removeClass: (/**
             * @param {?} className
             * @return {?}
             */
            (className) => this._getHostElement().classList.remove(className)),
            hasClass: (/**
             * @param {?} className
             * @return {?}
             */
            (className) => this._getHostElement().classList.contains(className)),
            activateIndicator: (/**
             * @param {?} previousIndicatorClientRect
             * @return {?}
             */
            (previousIndicatorClientRect) => this.tabIndicator.activate(previousIndicatorClientRect)),
            deactivateIndicator: (/**
             * @return {?}
             */
            () => this.tabIndicator.deactivate()),
            notifyInteracted: (/**
             * @return {?}
             */
            () => this.interacted.emit({ detail: { tabId: this.id, tab: this } })),
            getOffsetLeft: (/**
             * @return {?}
             */
            () => this._getHostElement().offsetLeft),
            getOffsetWidth: (/**
             * @return {?}
             */
            () => this._getHostElement().offsetWidth),
            getContentOffsetLeft: (/**
             * @return {?}
             */
            () => this.content.nativeElement.offsetLeft),
            getContentOffsetWidth: (/**
             * @return {?}
             */
            () => this.content.nativeElement.offsetWidth),
            focus: (/**
             * @return {?}
             */
            () => this._getHostElement().focus())
        };
        return new MDCTabFoundation(adapter);
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this._foundation.init();
        this._loadListeners();
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        this._ripple = this._createRipple();
        this._ripple.init();
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this._destroy.next();
        this._destroy.complete();
        this._ripple.destroy();
    }
    /**
     * Getter for the active state of the tab
     * @return {?}
     */
    get active() {
        return this._foundation.isActive();
    }
    /**
     * Activates the tab
     * @param {?=} computeIndicatorClientRect
     * @return {?}
     */
    activate(computeIndicatorClientRect) {
        this._foundation.activate(computeIndicatorClientRect);
    }
    /**
     * Deactivates the tab
     * @return {?}
     */
    deactivate() {
        this._foundation.deactivate();
    }
    /**
     * Returns the indicator's client rect
     * @return {?}
     */
    computeIndicatorClientRect() {
        return this.tabIndicator.computeContentClientRect();
    }
    /**
     * @return {?}
     */
    computeDimensions() {
        return this._foundation.computeDimensions();
    }
    /**
     * @return {?}
     */
    getTabBarParent() {
        return this._parent;
    }
    /**
     * @return {?}
     */
    focus() {
        this._getHostElement().focus();
    }
    /**
     * @private
     * @return {?}
     */
    _createRipple() {
        /** @type {?} */
        const rippleSurface = (/** @type {?} */ (this.rippleSurface.nativeElement));
        /** @type {?} */
        const adapter = Object.assign(Object.assign({}, MdcRipple.createAdapter(this)), { addClass: (/**
             * @param {?} className
             * @return {?}
             */
            (className) => rippleSurface.classList.add(className)), removeClass: (/**
             * @param {?} className
             * @return {?}
             */
            (className) => rippleSurface.classList.remove(className)), updateCssVariable: (/**
             * @param {?} varName
             * @param {?} value
             * @return {?}
             */
            (varName, value) => rippleSurface.style.setProperty(varName, value)) });
        return new MdcRipple(this.elementRef, new MDCRippleFoundation(adapter));
    }
    /**
     * @private
     * @return {?}
     */
    _loadListeners() {
        this._ngZone.runOutsideAngular((/**
         * @return {?}
         */
        () => fromEvent(this._getHostElement(), 'click').pipe(takeUntil(this._destroy))
            .subscribe((/**
         * @return {?}
         */
        () => this._ngZone.run((/**
         * @return {?}
         */
        () => {
            if (!this.active && !this._disabled) {
                this._foundation.handleClick();
            }
        }))))));
    }
    /**
     * Retrieves the DOM element of the component host.
     * @private
     * @return {?}
     */
    _getHostElement() {
        return this.elementRef.nativeElement;
    }
}
MdcTab.ɵfac = function MdcTab_Factory(t) { return new (t || MdcTab)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.MdcRipple), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(MDC_TAB_BAR_PARENT_COMPONENT, 8)); };
MdcTab.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MdcTab, selectors: [["", "mdcTab", ""], ["mdc-tab"]], viewQuery: function MdcTab_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, true);
        ɵngcc0.ɵɵviewQuery(_c1, true);
        ɵngcc0.ɵɵviewQuery(MdcTabIndicator, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.content = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.rippleSurface = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.tabIndicator = _t.first);
    } }, hostAttrs: ["role", "tab", 1, "mdc-tab"], hostVars: 7, hostBindings: function MdcTab_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵhostProperty("id", ctx.id);
        ɵngcc0.ɵɵclassProp("mdc-tab--stacked", ctx.stacked)("mdc-tab--min-width", ctx.fixed)("ngx-mdc-tab--disabled", ctx.disabled);
    } }, inputs: { id: "id", stacked: "stacked", fixed: "fixed", disabled: "disabled", focusOnActivate: "focusOnActivate", label: "label", icon: "icon" }, outputs: { interacted: "interacted" }, exportAs: ["mdcTab"], features: [ɵngcc0.ɵɵProvidersFeature([MdcRipple]), ɵngcc0.ɵɵInheritDefinitionFeature], attrs: _c2, ngContentSelectors: _c4, decls: 12, vars: 4, consts: [[1, "mdc-tab__content"], ["content", ""], ["class", "mdc-tab__icon", 4, "ngIf"], ["class", "mdc-tab__text-label", 4, "ngIf"], [4, "ngIf"], ["indicator", ""], [1, "mdc-tab__ripple"], ["ripplesurface", ""], [1, "mdc-tab__icon"], [1, "mdc-tab__text-label"], [4, "ngTemplateOutlet"]], template: function MdcTab_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c3);
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵtemplate(2, MdcTab_mdc_icon_2_Template, 2, 1, "mdc-icon", 2);
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵtemplate(4, MdcTab_span_4_Template, 2, 1, "span", 3);
        ɵngcc0.ɵɵprojection(5, 1);
        ɵngcc0.ɵɵtemplate(6, MdcTab_ng_container_6_Template, 2, 1, "ng-container", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(7, MdcTab_ng_container_7_Template, 2, 1, "ng-container", 4);
        ɵngcc0.ɵɵtemplate(8, MdcTab_ng_template_8_Template, 1, 0, "ng-template", null, 5, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelement(10, "div", 6, 7);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.icon);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.label);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.fixed);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.fixed);
    } }, directives: [ɵngcc2.NgIf, ɵngcc3.MdcIcon, ɵngcc2.NgTemplateOutlet, ɵngcc4.MdcTabIndicator], encapsulation: 2, changeDetection: 0 });
/** @nocollapse */
MdcTab.ctorParameters = () => [
    { type: NgZone },
    { type: ChangeDetectorRef },
    { type: MdcRipple },
    { type: ElementRef },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [MDC_TAB_BAR_PARENT_COMPONENT,] }] }
];
MdcTab.propDecorators = {
    id: [{ type: Input }],
    label: [{ type: Input }],
    icon: [{ type: Input }],
    stacked: [{ type: Input }],
    fixed: [{ type: Input }],
    disabled: [{ type: Input }],
    focusOnActivate: [{ type: Input }],
    interacted: [{ type: Output }],
    content: [{ type: ViewChild, args: ['content', { static: false },] }],
    rippleSurface: [{ type: ViewChild, args: ['ripplesurface', { static: false },] }],
    tabIndicator: [{ type: ViewChild, args: [MdcTabIndicator, { static: false },] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcTab, [{
        type: Component,
        args: [{ selector: '[mdcTab], mdc-tab',
                exportAs: 'mdcTab',
                host: {
                    '[id]': 'id',
                    'role': 'tab',
                    'class': 'mdc-tab',
                    '[class.mdc-tab--stacked]': 'stacked',
                    '[class.mdc-tab--min-width]': 'fixed',
                    '[class.ngx-mdc-tab--disabled]': 'disabled'
                },
                template: `
  <div #content class="mdc-tab__content">
    <mdc-icon class="mdc-tab__icon" *ngIf="icon">{{icon}}</mdc-icon>
    <ng-content select="mdc-icon"></ng-content>
    <span class="mdc-tab__text-label" *ngIf="label">{{label}}</span>
    <ng-content></ng-content>
    <ng-container *ngIf="fixed">
      <ng-container *ngTemplateOutlet="indicator"></ng-container>
    </ng-container>
  </div>
  <ng-container *ngIf="!fixed">
    <ng-container *ngTemplateOutlet="indicator"></ng-container>
  </ng-container>
  <ng-template #indicator><mdc-tab-indicator></mdc-tab-indicator></ng-template>
  <div #ripplesurface class="mdc-tab__ripple"></div>
  `,
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                providers: [MdcRipple] }]
    }], function () { return [{ type: ɵngcc0.NgZone }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc1.MdcRipple }, { type: ɵngcc0.ElementRef }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [MDC_TAB_BAR_PARENT_COMPONENT]
            }] }]; }, { id: [{
            type: Input
        }], interacted: [{
            type: Output
        }], stacked: [{
            type: Input
        }], fixed: [{
            type: Input
        }], disabled: [{
            type: Input
        }], focusOnActivate: [{
            type: Input
        }], label: [{
            type: Input
        }], icon: [{
            type: Input
        }], content: [{
            type: ViewChild,
            args: ['content', { static: false }]
        }], rippleSurface: [{
            type: ViewChild,
            args: ['ripplesurface', { static: false }]
        }], tabIndicator: [{
            type: ViewChild,
            args: [MdcTabIndicator, { static: false }]
        }] }); })();

/**
 * @fileoverview added by tsickle
 * Generated from: tab/module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const TAB_DECLARATIONS = [
    MdcTab,
    MdcTabIcon,
    MdcTabLabel
];
class MdcTabModule {
}
MdcTabModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MdcTabModule });
MdcTabModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function MdcTabModule_Factory(t) { return new (t || MdcTabModule)(); }, imports: [[
            CommonModule,
            MdcTabIndicatorModule,
            MdcIconModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MdcTabModule, { declarations: function () { return [MdcTab, MdcTabIcon, MdcTabLabel]; }, imports: function () { return [CommonModule,
        MdcTabIndicatorModule,
        MdcIconModule]; }, exports: function () { return [MdcTab, MdcTabIcon, MdcTabLabel]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcTabModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    MdcTabIndicatorModule,
                    MdcIconModule
                ],
                exports: TAB_DECLARATIONS,
                declarations: TAB_DECLARATIONS
            }]
    }], null, null); })();

export { MDC_TAB_BAR_PARENT_COMPONENT, MdcTab, MdcTabIcon, MdcTabLabel, MdcTabModule };

//# sourceMappingURL=tab.js.map